import styled, { css, keyframes } from 'styled-components'

import { IconV2 } from '../Icon'

const InAnimationOverlay = keyframes`
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
`

const OutAnimationOverlay = keyframes`
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
`

const InAnimationSidePanel = keyframes`
  0% {
    transform: translateX(500px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`

const OutAnimationSidePanel = keyframes`
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    transform: translateX(500px);
    opacity: 0;
  }
`

export const Overlay = styled.div<{ $opened: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: flex-start;
  justify-content: right;
  z-index: 1005;
  background: rgba(0, 0, 0, 0.4);

  ${(p) =>
    p.$opened
      ? css`
          opacity: 1;
          animation: ${InAnimationOverlay} 150ms ease-out;
        `
      : css`
          opacity: 0;
          animation: ${OutAnimationOverlay} 150ms ease-out;
        `};
`

export const Box = styled.div<{ $opened: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 500px;
  display: flex;
  flex-direction: column;
  box-shadow: var(--theme-boxShadows-offset-offset100Y4);
  background: var(--theme-colors-global-general-main);
  border-left: 1px solid var(--theme-colors-global-grey-grey300);
  z-index: 1005;

  ${(p) =>
    p.$opened
      ? css`
          opacity: 1;
          animation: ${InAnimationSidePanel} 250ms ease-out;
        `
      : css`
          opacity: 0;
          animation: ${OutAnimationSidePanel} 250ms ease-out;
        `};
`

export const Header = styled.header`
  height: 70px;
  min-height: 70px;
  font: var(--theme-typography-h2-semiBold);
  display: flex;
  align-items: center;
  padding: 0 24px;
  border-bottom: 1px solid var(--theme-colors-global-grey-grey300);
`

export const HeaderInside = styled.div`
  overflow: hidden;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  width: 400px;
`

export const Content = styled.section<{ $withoutPadding: boolean }>`
  padding: ${(p) => (p.$withoutPadding ? '0' : '24px')};
  overflow-y: auto;
`

export const Footer = styled.footer`
  border-top: 1px solid var(--theme-colors-global-grey-grey300);
  height: 66px;
  display: flex;
  align-items: center;
  padding: 24px;
  margin-top: auto;
  gap: 12px;
`

export const CloseIcon = styled(IconV2)`
  transition: color 0.15s;
  position: absolute;
  top: 22px;
  right: 22px;
  cursor: pointer;
  color: var(--theme-colors-global-grey-grey700);
  &:hover {
    color: var(--theme-colors-global-general-secondary);
  }
`
